var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4672 -0.000488281H4.532C1.8208 -0.000488281 0 1.90191 0 4.73311V11.2667C0 14.0971 1.8208 15.9995 4.532 15.9995H11.4664C14.1776 15.9995 16 14.0971 16 11.2667V4.73311C16 1.90191 14.1784 -0.000488281 11.4672 -0.000488281Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47863 5.91846C6.41462 5.91846 7.19862 6.54246 7.45462 7.39846H12.0146C12.3426 7.39846 12.6146 7.67046 12.6146 7.99846V9.47846C12.6146 9.81446 12.3426 10.0785 12.0146 10.0785C11.6786 10.0785 11.4146 9.81446 11.4146 9.47846V8.59846H10.3506V9.47846C10.3506 9.81446 10.0786 10.0785 9.75062 10.0785C9.41462 10.0785 9.15062 9.81446 9.15062 9.47846V8.59846H7.45462C7.19862 9.45446 6.41462 10.0785 5.47863 10.0785C4.32662 10.0785 3.39062 9.15046 3.39062 7.99846C3.39062 6.85446 4.32662 5.91846 5.47863 5.91846ZM5.47863 7.11846C4.99063 7.11846 4.59062 7.51046 4.59062 7.99846C4.59062 8.48646 4.99063 8.87846 5.47863 8.87846C5.95863 8.87846 6.35862 8.48646 6.35862 7.99846C6.35862 7.51046 5.95863 7.11846 5.47863 7.11846Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword2);
export default __webpack_public_path__ + "static/media/Password2.59dd322e.svg";
export { ForwardRef as ReactComponent };